import * as React from "react"
import { Box, Text, Link, Icon, Tag, Checkbox } from "@chakra-ui/react"
import { FiExternalLink } from "react-icons/fi"

import { rawItems } from "./raw-items"

export interface IItem {
  id: string
  name: string
  verb: string[]
  moods: string[]
  withWhom: string[]
  location?: string[]
  description?: string
  preparation?: string
  preparationType?: string
  ingredients?: string[]
  optionalIngredients?: string[]
  tags?: string[]
  link?: string[]
}

export const items = rawItems as { [key: string]: IItem }
export const itemValues = Object.values(items)

export interface ItemFilter {
  moods: string[]
  withWhom: "myself" | "friends"
  moodFilter?: "AND" | "OR"
  location?: "indoors" | "outdoors" | "indoors and outdoors"
  when?: "today" | "later"
  noScreens?: boolean
}

export const itemMatches = (item: IItem, f?: ItemFilter): boolean => {
  if (!f) {
    return true
  }

  if (f.when === "today" && item.preparationType) {
    return false
  }
  if (f.withWhom && !item.withWhom.includes(f.withWhom)) {
    return false
  }
  if (
    (f.location === "indoors" || f.location === "outdoors") &&
    !item.location?.includes(f.location)
  ) {
    return false
  }
  if (
    f.noScreens &&
    (item.tags?.includes("screens") || item.tags?.includes("look up"))
  ) {
    return false
  }

  if (f.moods?.length) {
    if (f.moodFilter === "OR") {
      for (let i = 0; i < item.moods.length; i++) {
        if (f.moods.includes(item.moods[i])) {
          return true
        }
      }
      return false
    } else {
      for (let i = 0; i < f.moods.length; i++) {
        if (!item.moods.includes(f.moods[i])) {
          return false
        }
      }
      return true
    }
  }

  return true
}

// @TODO make it pop
const rand = (arr: any[]) => {
  const i = Math.floor(Math.random() * arr.length)
  return arr[i]
}

// @TODO hover state should brighten/darken the color
const colors = [
  "red.500",
  "orange.500",
  "teal.500",
  "green.500",
  "purple.500",
  "pink.500",
  "cyan.500",
  "blue.500",
  "yellow.500",
]
const colorMap: { [key: string]: string } = {}

export const Item: React.FC<
  IItem & {
    selected?: boolean
    hideCheckbox?: boolean
    toggleItemSelection(itemId: string): void
  }
> = (props) => {
  const verb = rand(props.verb)
  let color = colorMap[verb]
  if (!color) {
    color = rand(colors)
    colorMap[verb] = color
  }
  return (
    <Box>
      <Box
        cursor={props.hideCheckbox ? "default" : "pointer"}
        onClick={() =>
          !props.hideCheckbox && props.toggleItemSelection(props.id)
        }
        display="inline-block"
      >
        {!props.hideCheckbox && (
          <>
            <Checkbox verticalAlign="unset" isChecked={props.selected} />{" "}
          </>
        )}

        <Text color={color} display="inline">
          {verb}{" "}
        </Text>
        {props.name.toLowerCase()}
        {props.link?.map((link, j) => (
          <Link
            key={j}
            href={link}
            target="_blank"
            onClick={(e) => e.stopPropagation()}
          >
            {" "}
            <Icon as={FiExternalLink} />
          </Link>
        ))}
        {/*({props.moods.join(",")})*/}
        {props.preparationType && (
          <Tag
            ml={4}
            verticalAlign="text-bottom"
            opacity="0.5"
            textTransform="lowercase"
          >
            {props.preparationType}
          </Tag>
        )}
      </Box>
    </Box>
  )
}
